<template>
    <div id="navData">
        <screen ref='screen'></screen>
    </div>
</template>

<script>

import Screen from 'views/cdu/cduHeader/Screen'
import {initNanData} from 'utils/initPageData'

export default { 
    name: 'NavData',
    components: {
        Screen
    },
    data() {
        return {
            showData: [],

            // index会变成[1,2]
            index:[],
            page1: [
                [
                    ['REF NAV DATA',['','','']], 
                    [1,1]
                ],
                [
                    [ 'WPT IDENT', 'NAVAID IDENT' ], 
                    [ '−−−−', '−−−−' ] 
                ], 
                [ 
                    [ 'AIRPORT IDENT', '' ], 
                    [ '−−−−', 'SUMMY>' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '−−−−−−−−−−−−−−−−−−−−', '' ], 
                    [ '<INDEX', 'NAV OPTIONS>' ] 
                ],
            ]
        }
    },
    methods: {
        initPage(){
            this.index = this.page1[0][1]
            this.showData = this['page'+ this.index[0]]
        }
    },
    created() {
        this.initPage()
        initNanData(this)
    },
    watch: {
        'index': {
            handler(newV, oldV){
                initNanData(this)
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>

</style>